import React, { Component } from 'react';
import { Provider } from 'mobx-react';
import Billy from '@/Billy';
import * as stores from '~/stores';

export default class App extends Component {
  render() {
    return (
      <Provider { ...stores } >
        <Billy />
      </Provider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/App.js